import { Injectable, inject } from "@angular/core";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { iif, insertItem, patch, updateItem } from "@ngxs/store/operators";
import { tap } from "rxjs/operators";
import { JsonSchemaApiService } from "../api/json-schema-api.service";
import { JsonSchemaStateModel, Schema } from "../models/json-schema-state";
import * as JsonSchemaActions from "./json-schema.actions";

@State<JsonSchemaStateModel>({
  name: "jsonSchemaState",
  defaults: {
    schemas: [],
    errors: []
  }
})
@Injectable()
export class JsonSchemaState {
  private readonly apiService = inject(JsonSchemaApiService);

  @Selector()
  public static schemas(state: JsonSchemaStateModel): Schema[] {
    return [...state.schemas];
  }

  @Action(JsonSchemaActions.UpdateState)
  updateState(ctx: StateContext<JsonSchemaStateModel>, { state }: JsonSchemaActions.UpdateState) {
    return ctx.patchState(state);
  }

  @Action(JsonSchemaActions.GetSchema)
  getSchema(ctx: StateContext<JsonSchemaStateModel>, { name }: JsonSchemaActions.GetSchema) {
    return this.apiService.get(name).pipe(
      tap(schema => {
        ctx.setState(
          patch({
            schemas: insertOrUpdate(name, {
              name: name,
              schema: schema
            } as Schema)
          })
        );
      })
    );
  }
}

const insertOrUpdate = (name: string, schema: Schema) => {
  return iif<Schema[]>(
    schemas => schemas?.some(s => s.name === name) ?? false,
    updateItem<Schema>(item => item?.name === name, patch(schema)),
    insertItem<Schema>(schema)
  );
};
